import React, { useEffect, useState } from 'react'
import SalesMarketing from '../SalesMarketing'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { getSalesMarketingByStatusTempo } from '../../../../models/sales/marketing/sales_marketing_m';

import { NumericFormat } from 'react-number-format';
import { Button } from '@mui/material';
import Moment from 'react-moment';
import Paginate from '../../../pagination/Paginate';

const SalesMarketingTempo = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [sales, setSales] = useState([]);
    const [pagination, setPagination] = useState([]);

    const getData = async(page) => {
        try {
            const data = {
                status_tempo: 'true',
                page: page
            }
            const response = await dispatch(getSalesMarketingByStatusTempo(data)).unwrap().catch((err) => {});
            setSales(response.data)
            setPagination(response.pagination)
        } catch (error) {
            
        }
    }

    useEffect(() => {
        getData(1)
    },[])

    const handlePagination = (_, page) => {
        return getData(page);
    }

    const onDetail = (code) => {
        return navigate(`${code}`)
    }

    return (
        <SalesMarketing>
            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive mb-3">
                            <table className="table align-middle">
                                <thead>
                                    <tr>
                                        <th className="table-border-start text-center" style={{width: '5%'}}>
                                            <span className="form-control fw-bold">No</span>  
                                        </th>
                                        <th>
                                            <span className="form-control fw-bold">Kode Transaksi</span>
                                        </th>
                                        <th>
                                            <span className="form-control fw-bold">Tanggal Transaksi</span>
                                        </th>
                                        <th>
                                            <span className="form-control fw-bold">Nama Marketing</span>
                                        </th>
                                        <th className="text-center" style={{width: '15%'}}>
                                            <span className="form-control fw-bold">Status Pembayaran</span>
                                        </th>
                                        <th>
                                            <span className="form-control fw-bold">Total Transaksi</span>
                                        </th>
                                        <th className="table-border-end text-center" style={{width: '10%'}}>
                                            <span className="form-control fw-bold">Action</span>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        sales.length > 0 ?
                                        sales.map((data) => (
                                            <tr key={data.no}>
                                                <td className="text-center">{data.no}</td>
                                                <td>{data.code}</td>
                                                <td>
                                                    <Moment format="dddd, DD MMMM YYYY">{data.date}</Moment>
                                                </td>
                                                <td>{data.marketing}</td>
                                                <td className="text-center">
                                                    {
                                                        data.status_pembayaran === 'lunas' ?
                                                        <span className="badge bg-green">Lunas</span> :
                                                        <span className="badge bg-danger">Belum Lunas</span>
                                                    }
                                                </td>
                                                <td>
                                                    <NumericFormat 
                                                        value={ data.total_pembayaran } 
                                                        allowLeadingZeros 
                                                        thousandSeparator="," 
                                                        valueIsNumericString
                                                        prefix="Rp. "
                                                        displayType="text"
                                                        renderText={(value) => <span>{value}</span>}
                                                    /> 
                                                </td>
                                                <td className="text-center">
                                                    <Button onClick={() => onDetail(data.code)} size="small" variant="contained" color="success">
                                                        Detail
                                                    </Button>
                                                </td>
                                            </tr>
                                        )): 
                                        <tr>
                                            <th colSpan={6} className="text-center">DATA TEMPO PENJUALAN TIDAK DITEMUKAN</th>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>

                        {/* pagination */}
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <span>Halaman : { pagination.current_page }</span>
                            </div>
                            {
                                pagination.pagination ?
                                <Paginate count={pagination.total} page={pagination.current_page} onChange={handlePagination} /> : ''
                            }
                            <div>
                                <span>Total : { pagination.total } Tempo Penjualan</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </SalesMarketing>
    )
}

export default SalesMarketingTempo
